import React, { useCallback, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Alert, Image, Upload } from "antd";

import { config } from "../../config";
import { getUserDetail } from "../../utils/helper";

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const ProjectThumbnail = ({ project }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState(
    project.filePath
      ? [
          {
            uid: project.id,
            name: `image-${project.id}`,
            status: "done",
            url: `${config.filesBaseUrl}/${project.filePath}`,
          },
        ]
      : []
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = useCallback(
    ({ fileList: newFileList, file }) => {
      if (file.status !== "done") {
        setFileList(newFileList);
      } else {
        const index = newFileList.findIndex((f) => f.uid === file.uid);

        if (index !== -1) {
          const { id, filePath } = file.response;
          newFileList = [
            {
              uid: id,
              name: `image-${id}`,
              status: "done",
              url: `${config.filesBaseUrl}/${filePath}`,
            },
          ];

          setFileList(newFileList);
        }
      }
    },
    [setFileList]
  );

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <UploadOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        {fileList.length ? "Update" : "Upload"}
      </div>
    </button>
  );
  return (
    <>
      <Alert
        message="Recommended file size: max 500KB."
        type="warning"
        style={{ marginTop: "4px", marginBottom: "16px" }}
      ></Alert>
      <Upload
        action={`${config.apiBaseUrl}/project/updateThumbnail/${project.id}`}
        accept=".jpeg,.jpg,.png"
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        headers={{ Authorization: `Bearer ${getUserDetail()?.accessToken}` }}
        onChange={handleChange}
        onRemove={false}
      >
        {uploadButton}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};
